import { Component, OnInit } from '@angular/core';
import { ConsorciosService } from '../../services/consorcios.service';
import { CatalogoCobroService } from '../../services/catalogo-cobro.service';


import { Consorcio } from '../../model/consorcio';
import { CatalogoCobro } from '../../model/catalogo-cobro';

@Component({
  selector: 'app-catalogo-cobro-list',
  templateUrl: './catalogo-cobro-list.component.html',
  styleUrls: ['./catalogo-cobro-list.component.css']
})
export class CatalogoCobroListComponent implements OnInit {

  public modoEdicion: boolean = false;

  public consorcio: Consorcio;
  public consorcios: Consorcio[];
  public catalogos: CatalogoCobro[];
  public catalogoSeleccionado: CatalogoCobro;
  public query: any;

  public filtro:string;

  constructor(
    private _consorcioService: ConsorciosService,
    private _cobroService: CatalogoCobroService

  ) { }

  ngOnInit() {
    this.filtro = "";
    this.catalogos = [];
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.catalogoSeleccionado = new CatalogoCobro();
    this.cargarConsorcios();

  }

  cargarConsorcios() {

    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
      });

  }

  cargarCobros() {

    if (this.consorcio === null) {
      return;
    }

    this._cobroService.getCobros(this.consorcio)
      .subscribe(
      data => this.catalogos = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }


  agregarRegistro() {
    if (this.consorcio === undefined) {
      return;
    }
    this.catalogoSeleccionado = new CatalogoCobro();

    this.modoEdicion = true;
  }

  regresar() {
    this.modoEdicion = false;
    this.cargarCobros();
  }


  editarRegistro(catalogoCobro: CatalogoCobro) {
    this.catalogoSeleccionado = catalogoCobro;
    this.modoEdicion = true;
  }


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/catalogo-cobro-list/catalogo-cobro-list.component.ts